export default __webpack_public_path__ + "static/media/EDO placemat.b38c2142.zip";